import {get} from 'lodash'

const setStyles = (array, styles, error) => {
  return array.map(input => {
    const getStyles = get(styles, input.styleProps, styles.default)
    input.style = getStyles || ''
    return input
  })
}

export default setStyles



// WEBPACK FOOTER //
// ./src/constants/Forms/setStyles.js